const PATCH_ASSIGNMENT_MUTATION = `
    mutation patchAssignment($input: PatchAssignmentInput!) {
        result: patchAssignment(input: $input) {
            id
            status
            score
            scormState
            createdAt
            updatedAt
        }
    }
`;

const getPatchAssignmentMutation = ( options = {} ) => {
    const result = {
        query: PATCH_ASSIGNMENT_MUTATION,
        operationName: 'patchAssignment',
        variables: { ...options }
    };

    return JSON.stringify( result );
};

export default getPatchAssignmentMutation;
